import { render } from "./BillView.vue?vue&type=template&id=171b3d54&scoped=true"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"

import "./BillView.vue?vue&type=style&index=0&id=171b3d54&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b3d54"]])

export default __exports__